<template>
  <div>
    <b-modal
      ref="batch-modal"
      centered
      hide-footer
      :size="type == 'Batch' ? 'lg' : 'md'"
      no-close-on-esc
      no-close-on-backdrop
      @hidden="closeModal"
    >
      <template v-slot:modal-title>Select {{ type }}</template>

      <div
        class="d-block  negative-margin "
        :class="{ 'group-listing': type == 'Batch' }"
      >
        <b-row class="py-2 fs-11 activites-bar">
          <b-col :md="type == 'Batch' ? '4' : '12'">
            <b-row>
              <b-col md="2">&nbsp;</b-col>
              <b-col md="6">{{ type }} Number</b-col>
              <b-col md="4">MRP</b-col>
            </b-row>
          </b-col>
          <b-col md="8" v-if="type == 'Batch'">
            <b-row>
              <b-col md="4" offset-md="1">Manufacture date</b-col>
              <b-col md="3">Expiry date</b-col>
              <b-col md="4">Best before / Valid till</b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row
          class="py-2 batch-list align-items-center"
          v-for="(list, index) in BatchList"
          :key="index"
        >
          <b-col :md="type == 'Batch' ? '4' : '12'">
            <b-row class="align-items-center">
              <b-col md="2">
                <b-form-radio
                  name="radio-options"
                  v-model="selected"
                  :value="list"
                  :id="list.code"
                />
              </b-col>
              <b-col md="6"><span v-text="list.code"/></b-col>
              <b-col md="4"
                ><span v-text="currencySymbol + formatAmount(list.mrp)" />
              </b-col>
            </b-row>
          </b-col>
          <b-col md="8" v-if="type == 'Batch'">
            <b-row>
              <b-col md="4" offset-md="1">
                <span v-if="list.mfg_date === null" class="text-muted">
                  Not specified</span
                >
                <span v-else v-text="list.mfg_date"></span
              ></b-col>
              <b-col md="3">
                <span v-if="list.exp_date === null" class="text-muted">
                  Not specified</span
                >
                <span
                  v-if="checkExpiryDate > list.exp_date"
                  :class="[
                    checkExpiryDate > list.exp_date
                      ? 'text-danger d-flex align-items-center'
                      : '',
                  ]"
                >
                  {{ list.exp_date }}&nbsp;
                  <font-awesome-icon
                    :icon="['fa', 'exclamation-circle']"
                    class="text-danger fs-11"
                  />
                </span>
              </b-col>
              <b-col md="4"
                ><span
                  v-text="list.validty"
                  :class="[list.validty == 'N/A' ? 'text-muted' : '']"
                ></span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col md="3" offset="9">
          <div class="text-right mt-3">
            <b-button
              class="mt-3"
              variant="primary"
              id="confirm-selected-btn"
              @click="expriryWarning"
              :disabled="$loading"
              block
            >
              <span v-if="$loading == false">Confim Selected</span>
              <b-spinner small v-if="$loading == true"></b-spinner>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      title="Expired Product"
      id="expire-product-modal"
      ref="expire-product-modal"
      size="sm"
    >
      <b-row>
        <b-col md="12">
          <p v-text="msg.EXPIRED_BATCH" />
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="6" class="pr-1">
          <b-button
            variant="outline-primary"
            @click="$refs['expire-product-modal'].hide()"
            block
            >Dismiss</b-button
          >
        </b-col>
        <b-col md="6" class="pl-1">
          <b-button
            variant="primary"
            @click="checkProductInCart(), $refs['expire-product-modal'].hide()"
            block
            >Continue</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <update-qty-modal
      :open="openBox"
      :data="productDetails"
      @close-modal="boxClose"
      :pluQty="pluQty"
      :toCart="true"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as msg from "../message";
import UpdateQtyModal from "./UpdateQtyModal";
import moment from "moment";
export default {
  name: "batch-serial-modal",
  props: {
    open: { default: false, type: Boolean },
    batchSerialData: { trpe: String },
    pluQty: { type: String },
  },
  components: { UpdateQtyModal },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    checkExpiryDate() {
      // let date = moment().isBetween('2016-10-30', '2016-12-30', undefined, '()');
      let date = moment().format("YYYY-MM-DD");
      return date;
    },
    msg() {
      return msg;
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.BatchList = this.batchSerialData.batchList;
        this.type = this.batchSerialData.type;
        this.pdata = this.batchSerialData.pdata;
        this.selected = this.batchSerialData.batchList[0];
        this.$refs["batch-modal"].show();
      } else {
        this.$refs["batch-modal"].hide();
      }
    },
  },
  data() {
    return {
      BatchList: [],
      type: "",
      pdata: {},
      selected: "",
      openBox: false,
      productDetails: "",
    };
  },
  methods: {
    checkProductInCart() {
      if (this.pdata.weight_flag) {
        this.addToCart(this.pdata);
      } else {
        let existsItem = this.state.billing.billing.cart.data.filter((item) => {
          return (
            item.product_data.barcode == this.pdata.barcode &&
            item.unit_mrp == this.selected.mrp
          );
        });
        if (existsItem.length == 0) {
          this.addToCart();
        } else {
          console.log(
            existsItem[0].product_data.barcode + " " + existsItem[0].qty
          );
          if (
            parseInt(existsItem[0].qty) ==
            parseInt(this.state.system.settings.cart.product_max_qty)
          ) {
            console.log("max qty reached");
            let alertData = {
              message: msg.MAX_PRODUCT_QTY,
              type: "danger",
            };
            this.closeModal();
            this.$store.commit("notifications/showAlert", alertData);
            this.$showAlert = true;
          } else {
            this.addToCart();
          }
        }
      }
    },
    addToCart() {
      if (this.pdata.weight_flag) {
        this.productDetails = Object.assign(this.pdata, {
          change_mrp: this.selMrp,
          batch_id: this.type == "Batch" ? this.selected.id : 0,
          serial_id: this.type == "Serial" ? this.selected.id : 0,
        });
        this.openBox = true;
        if (typeof Android !== "undefined" && Android !== null) {
          let postData = { type: "read_weight", data: "" };
          returnValue(postData);
        }
        this.closeModal();
      } else {
        this.$loading = true;
        let productData = {
          barcode: this.pdata.barcode,
          scan: "TRUE",
          url: "product-details",
          qty: "",
          change_mrp: "",
          batch_id: this.type == "Batch" ? this.selected.id : 0,
          serial_id: this.type == "Serial" ? this.selected.id : 0,
          selected_batch_price:
            this.type == "Batch" ? parseFloat(this.selected.mrp).toFixed(2) : 0,
          selected_serial_price:
            this.type == "Serial"
              ? parseFloat(this.selected.mrp).toFixed(2)
              : 0,
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        };
        let data = Object.assign(
          productData,
          this.essentialsData,
          this.customerData
        );
        this.$store
          .dispatch("billing/addToCart", data)
          .then(() => {
            this.$store.dispatch("billing/cartDetails").then(() => {
              this.$loading = false;
              this.closeModal();
            });
          })
          .catch((err) => {
            this.closeModal();
            this.$loading = false;
            if (err.hasOwnProperty("status")) {
              if (err.status == "customer_not_tag") {
                let alertData = {
                  message: err.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
            } else {
              if (err.response.data.status == "product_not_found") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
              if (err.response.data.status == "fail") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;

                this.$store.commit("notifications/showAlert", alertData);
              }
            }
          });
      }
    },
    closeModal() {
      this.type = "";
      this.pdata = "";
      this.BatchList = [];
      this.selected = "";
      this.$emit("closeBatchSerialModal");
    },
    boxClose(data) {
      this.openBox = data;
      this.$emit("clear-plu-qty");
    },
    expriryWarning() {
      if (
        this.type == "Batch" &&
        this.compareDateFromToday(this.selected.exp_date)
      )
        this.$refs["expire-product-modal"].show();
      else this.checkProductInCart();
    },
  },
};
</script>

<style lang="scss" scoped>
/*.group-listing {
  height: calc(100vh - 230px);
  overflow: hidden;
  overflow-y: scroll;
  @include custom-scrollbar();
}*/
.batch-list {
  border-bottom: 1px solid $dark-card-title-header;
}
.negative-margin {
  margin: 0 -7px;
}
</style>
